import React from "react"
import { useSummaryData } from "../hooks/useSummaryData"
import { ClassName_EUIRolling12MonthTrend } from './summaryChartClassnames';
import { EUIRolling12MonthTrendBaseChart } from "@/components/base-chart/EUIRolling12MonthTrendBaseChart/EUIRolling12MonthTrendBaseChart"

export const config = {
  title: 'EUI Rolling 12 Month Trend (kBtu/sqft-yr)',
}

export const EUIRolling12MonthTrendChart = ({ period, endingMonth }) => {

  const { data: electricityData = { electricity: [] } } = useSummaryData('electricity', period, endingMonth)
  const { data: gasData = { gas: [] } } = useSummaryData('gas', period, endingMonth)

  return (
    <EUIRolling12MonthTrendBaseChart
      electricityData={electricityData.electricity}
      gasData={gasData.gas}
      title={config.title}
      className={ClassName_EUIRolling12MonthTrend}
      style={{ width: '100%', height: '100%' }}
    />
  )
}